import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  connect() {
    this.isOpen = false;
    window.addEventListener("toggle-nav-bar", this.toggle.bind(this));
  }

  disconnect() {
    window.removeEventListener("toggle-nav-bar", this.toggle.bind(this));
  }

  toggle() {
    if (this.isOpen) {
      this.closeModal();
    } else {
      this.contentTarget.classList.remove("pointer-events-none");
      this.contentTarget.parentElement.classList.remove("hidden");
      setTimeout(this.showContent.bind(this), 100);
    }
    this.isOpen = !this.isOpen;
  }

  closeModal() {
    this.contentTarget.classList.add("pointer-events-none");
    this.contentTarget.classList.add("-translate-x-full");
    setTimeout(this.addHiddenToModal.bind(this), 500);
  }

  addHiddenToModal() {
    this.contentTarget.parentElement.classList.add("hidden");
  }

  showContent() {
    this.contentTarget.classList.remove("-translate-x-full");
  }

  closeBackground(e) {
    if (!(e && this.contentTarget.contains(e.target))) {
      this.closeModal();
      this.isOpen = false;
    }
  }
}
